
import React from "react";
import {
    DefaultModuleHeader, ModuleEmptyButton, HomeWork, DEAL_STATUSES, LOAN_SENIORITY_TYPES, ButtonText, ButtonSizeOptions, MaterialIcon, ButtonBar, ModuleBase
} from '@loanbossinc/component-library';
import styled from "styled-components";
import PropTypes from "prop-types";
import { QuoteTable } from "./quoteTable";
import { DnDQuoteTable } from "./dndQuoteTable";


const StyledModuleBase = styled(ModuleBase)` && {    
    margin: auto;
    margin-top: 16px;
    box-shadow: -5px 0 8px #dadce0;
    width: 910px;
  }
`;

const StyledActiveQuoteContainer = styled.div`&&{
    background: #FAFAFA;
    /* Stroke / Gray */

    border: 1px solid #DADCE0;
    box-sizing: border-box;
    border-radius: 0px;
    height:47px;

}`;

const StyledActiveQuoteHeader = styled.div`&&{


    /* Work Sans / 12 Semibold CAPS */

    font-family: Work Sans;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 14px;
    /* identical to box height */

    display: flex;
    align-items: flex-end;
    text-transform: uppercase;
    margin-left 24px;
    margin-top 17px;
}`;
export default class DynamicQuoteGrid extends React.Component {
    state = {}

    renderHeaderButton = (compareQuotes) => {
        const { canCombineCompare } = this.props;
        if(!canCombineCompare) return null;
        return (
            <ButtonBar
                size={ButtonSizeOptions.smFluid}
                options={[
                    {
                        label: "Compare"
                        , index: 0
                        , onClick: compareQuotes
                    }
                ]}
            />
        );
    }

    renderQuoteTable = () => {
        const { shortList, quotes, quoteStatus, selectedQuote, history, deal, iconName, saveOrderChange, noSLDataMessage, noDataMessage, compareQuotes, hideShortList,columns,slColumns, onRowClick} = this.props;
        
        return (
            <StyledModuleBase>
                <DefaultModuleHeader
                    headerElement={[<MaterialIcon iconName={iconName} style={{ fontSize: '36px', color: '#C4C4C4' }} />]}
                    headerTitle={quoteStatus}
                    subTitle={""}
                    button={this.renderHeaderButton(compareQuotes)}
                />
                {!hideShortList && <DnDQuoteTable
                    data={shortList}
                    selectedQuote={selectedQuote}
                    history={history}
                    deal={deal}
                    saveOrderChange={saveOrderChange}
                    noDataMessage={noSLDataMessage}
                    columns={slColumns}
                    onRowClick={onRowClick}
                />}
                {!hideShortList && <StyledActiveQuoteContainer>
                    <StyledActiveQuoteHeader>{"Active Quotes"}</StyledActiveQuoteHeader>
                </StyledActiveQuoteContainer>}
                <QuoteTable
                    data={quotes}
                    selectedQuote={selectedQuote}
                    history={history}
                    deal={deal}
                    noDataMessage={noDataMessage}
                    columns={columns}
                    onRowClick={onRowClick}
                />
            </StyledModuleBase>)
    }

    render() {
        const { iconName, quoteStatus, reorderShortList, compareQuotes, shortList, quotes } = this.props;
        return (this.renderQuoteTable())
    }
}

DynamicQuoteGrid.propTypes = {
    iconName: PropTypes.string,
    quoteStatus: PropTypes.string,
    reorderShortList: PropTypes.func.isRequired,
    compareQuotes: PropTypes.func.isRequired,
    shortList: PropTypes.array,
    quotes: PropTypes.object.isRequired,
    selectedQuote: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    deal: PropTypes.object.isRequired,
};


